import React from 'react'
import styled from 'styled-components'
import { Section } from 'react-bulma-components'
import { Heading } from 'react-bulma-components'
import { Hero } from 'react-bulma-components'
import { Content } from 'react-bulma-components'
import { Container } from 'react-bulma-components'
import { device } from './device'
import ExpandButton from './ExpandButton'

export const StyledHeading = styled(Heading)`
    margin-top: 0.5rem;
    font-family: 'Rubik', sans-serif;
    font-weight: 100 !important;
    @media ${device.mobile} {
    }
`

export const NewStyledHeading = styled(Heading)`
    color: #faa735 !important;
    margin-top: 0.5rem;
    font-family: 'Rubik', sans-serif;
    font-weight: 100 !important;
    @media ${device.mobile} {
    }
`

export const NewStyledHeadingBlue = styled(Heading)`
    color: #00aec7 !important;
    margin-top: 0.5rem;
    font-family: 'Rubik', sans-serif;
    font-weight: 100 !important;
    @media ${device.mobile} {
    }
`

export const StyledHero = styled(Hero)`
    position: relative;
    //min-height: 600px;
    //background-color: #f9f9f9;
`
export const StyledContent = styled(Content)`
    font-family: 'Rubik', sans-serif;
    font-weight: 100 !important;
    //max-width: 700px;
    //margin: 0 auto;
    font-size: 20px;
    font-size: 1.2rem;
    @media ${device.mobile} {
        font-size: 1.2rem;
    }
`
export const StyledContainer = styled(Container)`
    @media ${device.widescreen} {
        //text-align: center !important;
    }
`
export const StyledButton = styled(ExpandButton)`
    &button {
        color: white !important;
        background-image: linear-gradient(120deg, #f6d365 0%, #fda085 100%);
    }
`

const StyledIconSpan = styled.span`
    -webkit-align-items: center;
    align-items: center;
    display: -webkit-inline-flex;
    display: inline-flex;
    -webkit-justify-content: center;
    justify-content: center;
    height: 3rem;
    width: 4rem;
    svg {
        height: 3rem;
        width: 4rem;
        path {
            ${(props) => (props.color ? 'fill:' + props.color : null)}
        }
    }
`

export const StyledIcon = (props) => {
    return (
        <StyledIconSpan
            {...props}
            className={props.className}
            color={props.color}
        >
            {props.icon}
        </StyledIconSpan>
    )
}

export const HeaderHero = styled(Hero)`
    min-height: 550px;
    @media ${device.mobile} {
        min-height: 400px;
    }
`
export const HeaderBody = styled(Hero.Body)`
    position: relative;
    flex-grow: 0;
    @media ${device.mobile} {
        padding: 0 1.5rem;
    }
`

export const HeaderContent = styled(StyledContent)`
    max-width: 700px;
    margin: 0;
    color: white;

    span {
        color: black;
    }
    p {
        text-shadow: 1px 1px 1px #0000001a;
        background-color: #00000021;
        border-radius: 10px;
        padding: 0.4em;
    }
`
export const HeaderHeading = styled(StyledHeading)`
    color: white !important;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.28);
    &.is-1 {
        font-size: 2.5rem;
    }
    &.is-2 {
        font-size: 2rem;
    }
    @media ${device.desktop} {
        &.is-1 {
            font-size: 5rem !important;
        }
        &.is-2 {
            font-size: 3rem !important;
        }
    }
`
export const HeaderSection = styled(Section)`
    margin-top: -100px;
    z-index: 1;
    @media ${device.mobile} {
        margin-top: -220px;
    }
`

export const KisikSection = styled(Section)`
    margin-top: 100px;
    padding: 0 !important;
`

export const HeaderButtonWrap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    max-width: 400px;
    margin-top: -3rem;
    @media ${device.tablet} {
        justify-content: flex-start;
    }
    div {
        &:not(:first-child) {
            margin-left: 1rem;
        }
    }
`

export const ArticleContent = styled(Content)`
    h1,
    h2,
    h3,
    h4 {
        font-family: 'Rubik', sans-serif;
        font-weight: 100 !important;
    }
`
